import React from "react";
import PropTypes from "prop-types";
import StarInput from "./starInput";

const RatingField = ({ label, name, value, onChange, showUpText = false }) => (
    <div className="overall-rating-list">
        <label className="cart-side-label">{label}:</label>
        <StarInput value={value} onChange={(val) => onChange(name, val)} name={name} showUpText={showUpText} />
    </div>
);

RatingField.propTypes = {
    label: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    value: PropTypes.number,
    onChange: PropTypes.func.isRequired,
    showUpText: PropTypes.bool,
};

export default RatingField;
